import type { BaseSelectionResponse } from "@frend-digital/centra-types/selection";

export const optimisticUpdateQuantity = (
  data: BaseSelectionResponse,
  variables: { newQuantity: number; line: string }
): BaseSelectionResponse => {
  if (!data.selection?.items) return data;

  const itemIndex = data.selection.items?.findIndex(
    (item) => item.line === variables.line
  );

  if (itemIndex === -1 || typeof itemIndex !== "number") return data;

  const item = data.selection.items?.at(itemIndex);
  if (!item) return data;

  const items = [...data.selection.items];
  if (variables.newQuantity === 0) {
    items.splice(itemIndex, 1);
  } else {
    items[itemIndex] = {
      ...item,
      quantity: variables.newQuantity,
    };
  }

  return {
    ...data,
    selection: {
      ...data.selection,
      items,
    },
  };
};
